import { render, staticRenderFns } from "./ChannelSelectionView.vue?vue&type=template&id=41dce4c1&scoped=true&"
import script from "./ChannelSelectionView.vue?vue&type=script&lang=js&"
export * from "./ChannelSelectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dce4c1",
  null
  
)

export default component.exports